// extracted by mini-css-extract-plugin
module.exports = {"button":"MealItemForm_button__15xIi"};